// extracted by mini-css-extract-plugin
export default {"utility":"NavBar_utility__9ztY0"};